import { ThemeColors } from "consts/theme";
import React from "react";
import { PaziaBadge } from "../PaziaBadge/PaziaBadge";
import { PaziaStatusLabel } from "../PaziaStatusLabel/PaziaStatusLabel";

interface PaziaBadgeStatusProps {
  children: React.ReactNode;
  color: ThemeColors;
  fill?: boolean;
  size?: "xs" | "sm";
  onClick?: () => void;
}

export const PaziaBadgeStatus = ({
  children,
  color,
  onClick,
  fill = false,
  size,
}: PaziaBadgeStatusProps): JSX.Element => {
  return (
    <PaziaBadge color={color} fill={fill} onClick={onClick} size={size}>
      <PaziaStatusLabel color={color} size={size}>
        {children}
      </PaziaStatusLabel>
    </PaziaBadge>
  );
};
